import React from "react";

import { ArrowUpward, Cancel, Done, EventAvailable, Group, HourglassEmpty, LocalTaxi, MoreHoriz, Warning } from "@material-ui/icons";

export const statusMap = {
    1:{
        'localStatus':'Pending',
        'tooltipText':'taxistatus_pending',
        'percent':12.5,
        'backgroundColor':'#4f73bd',
        'inMotion':false,
        'iconComponent':HourglassEmpty,
        'icon':<HourglassEmpty sx={{backgroundColor:'#4f73bd', color:'#FFFFFF'}}/>
    },
    2:{
        'localStatus':'Booked',
        'tooltipText':'taxistatus_booked',
        'percent':25,
        'backgroundColor':'#FFC000',
        'inMotion':false,
        'iconComponent':EventAvailable,
        'icon':<EventAvailable sx={{backgroundColor:'#FFC000', color:'#000000'}}/>
    },
    3:{
        'localStatus':'Accepted',
        'tooltipText':'taxistatus_accepted',
        'percent':40,
        'backgroundColor':'#80D3FF',
        'inMotion':true,
        'iconComponent':ArrowUpward,
        'icon':<ArrowUpward sx={{backgroundColor:'#80D3FF', color:'#FFFFFF'}}/>
    },
    4:{
        'localStatus':'Arrived',
        'tooltipText':'taxistatus_arrived',
        'percent':50,
        'backgroundColor':'#DE9307',
        'inMotion':true,
        'iconComponent':LocalTaxi,
        'icon':<LocalTaxi sx={{backgroundColor:'#DE9307', color:'#FFFFFF'}}/>
    },
    5:{
        'localStatus':'POB',
        'tooltipText':'taxistatus_pob',
        'percent':75,
        'backgroundColor':'#00B342',
        'inMotion':true,
        'iconComponent':Group,
        'icon':<Group sx={{backgroundColor:'#00B342', color:'#FFFFFF'}}/>
    },
    6:{
        'localStatus':'Complete',
        'tooltipText':'taxistatus_complete',
        'percent':100,
        'backgroundColor':'#0775C5',
        'inMotion':false,
        'iconComponent':Done,
        'icon':<Done sx={{backgroundColor:'#0775C5', color:'#FFFFFF'}}/>
    },
    7:{
        'localStatus':'Cancelled',
        'tooltipText':'taxistatus_cancelled',
        'percent':0,
        'backgroundColor':'#D84C1E',
        'inMotion':false,
        'iconComponent':Cancel,
        'icon':<Cancel sx={{backgrounColor:'#D84C1E', color:'#FFFFFF'}}/>
    },
    8:{
        'localStatus':'Unanswered',
        'tooltipText':'taxistatus_unanswered',
        'percent':0,
        'backgroundColor':'#D84C1E',
        'inMotion':false,
        'iconComponent':Warning,
        'icon':<Warning sx={{backgroundColor:'#D84C1E', color:'#FFFFFF'}}/>
    },
    9:{
        'localStatus':'Unconfirmed',
        'tooltipText':'taxistatus_unconfirmed',
        'percent':0,
        'backgroundColor':'#CCCCCC',
        'inMotion':false,
        'iconComponent':MoreHoriz,
        'icon':<MoreHoriz sx={{backgroundColor:'#CCCCCC', color:'#FFFFFF'}}/>
    }
};